import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

const PaymentMethodsLayout = () => {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack>
        <Stack.Screen
          name="index"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={'Select payment type'} />,
            headerLeft: () => <GoBackButton />
          }}
        />
        <Stack.Screen
          name="addCreditCard"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={i18n.t('credit_cards.add')} />,
            headerLeft: () => <GoBackButton />
          }}
        />
        <Stack.Screen
          name="creditCardList"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={i18n.t('mix.credit_cards')} />,
            headerLeft: () => <GoBackButton />
          }}
        />
        <Stack.Screen
          name="addAch"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={'ACH INFORMATION'} />,
            headerLeft: () => <GoBackButton />
          }}
        />
        <Stack.Screen
          name="achList"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={'ACH Accounts'} />,
            headerLeft: () => <GoBackButton />
          }}
        />
        <Stack.Screen
          name="billingAddress"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={'Billing Address'} />,
            headerLeft: () => <GoBackButton />
          }}
        />
      </Stack>
    </PlatformContainer>
  );
};

export default PaymentMethodsLayout;
